import { render } from "./FestivalPage.vue?vue&type=template&id=ccf286f4&scoped=true"
import script from "./FestivalPage.vue?vue&type=script&lang=js"
export * from "./FestivalPage.vue?vue&type=script&lang=js"

import "./FestivalPage.vue?vue&type=style&index=0&id=ccf286f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccf286f4"]])

export default __exports__